import { Box, CloseButton, Stack, Text } from "@mantine/core";
import { FC } from "react";
import ListItem from "./ListItem";

interface Props {
  practitioners: any[];
  onPractitionerSelected: (p: any) => void;
}

const ListView: FC<Props> = ({ practitioners, onPractitionerSelected }) => {
  return (
    <Box w="100vw" bg="white" pos="absolute" top="36px"
      style={{
        zIndex: 19,
        boxSizing: "border-box",
        height: "calc(100% - 36px)"
      }}>
      <Box px={25} mt={55} pos="relative">
        <Text fz={10} c="#8B8B8B" ta="right">
          Displaying accounts visible on map, sorted by distance to you
        </Text>
        {practitioners.length <= 40 ? (
          <>
            {practitioners.map((p, index) => (
              <ListItem
                onClick={() => onPractitionerSelected(p)}
                key={index}
                practitioner={p}
                index={index + 1} />
            ))}
          </>
        ) : (
          <Stack align="center" mt={120} gap={30} px={20}>
            <CloseButton bg="#E64B37" c="white" bdrs="50%" w={40} h={40} />
            <Text c="#E64B37" fz={20} ta="center">
              There are too many accounts on your map!
            </Text>
            <Text c="#E64B37" fz={20} ta="center">
              Please zoom in and we'll make this happen.
            </Text>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default ListView;